/**
 * Legacy MembershipApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.membershipApi`) keep
 * resolving.
 *
 * The actual `MembershipApiService` factory is now exposed indirectly: the
 * Angular 18 `ApiService` facade (registered as the downgraded `'ApiService'`
 * in apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts) exposes
 * `apiService.membership` as an `inject(MembershipApiService)` Angular 18
 * class. The actual implementation lives at
 *   apps/b2b-frontend/app/core/api/membership/membership-api.service.ts
 *
 * Do NOT register `.service('MembershipApiService', ...)` here — nothing
 * consumes it directly anymore.
 */
angular.module('acme.common.service.membershipApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion',
]);
